"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VizportalApiService = void 0;
var vizportal_webclient_api_1 = require("@tableau/vizportal-webclient-api");
var VizportalApiService = /** @class */ (function () {
    function VizportalApiService() {
    }
    VizportalApiService.getVizportalWebClientRequester = function () {
        if (!VizportalApiService.vizportalWebClientRequester) {
            VizportalApiService.vizportalWebClientRequester = new vizportal_webclient_api_1.VizPortalWebClientRequester();
        }
        return VizportalApiService.vizportalWebClientRequester;
    };
    return VizportalApiService;
}());
exports.VizportalApiService = VizportalApiService;
exports.default = VizportalApiService;
//# sourceMappingURL=VizportalApi.js.map